<template>
    <div>
        <div class="container-fluid" style="padding: 0;">
            <!-- Appraisals !-->
            <div class="row" style="font-size: 14px;">
                <div class="col-8">
                    <hr class="labeled" data-content="Vehicle">
                </div>
                <div class="col text-right">
                    <ui-button
                        size="small"
                        icon="add"
                        color="primary"
                        type="secondary"
                        :disabled="disabled||hasVehicle"
                        @click="addAppraisal"
                    >Add</ui-button>
                </div>
            </div>

             <div v-for="appraisal in appraisals">
                    <appraisal-snippet
                        :appraisal="appraisal"
                        @click="showAppraisal(appraisal)"
                        @remove="removeAppraisal(appraisal)"
                        :disabled="disabled"
                    ></appraisal-snippet>
            </div>

            <div v-if="appraisals.length === 0" style="margin-bottom: 1rem; font-size: 1rem;">
                No vehicles added
            </div>
        </div>

        <vehicle-appraisal-modal
            ref="appraisal"
            @identified="existingVehicleCheck"
            @save="finishAddingAppraisal"
        ></vehicle-appraisal-modal>
    </div>
</template>

<script>
import LeadPaneHelpers from "../lead/LeadPaneHelpers";
import VehicleAppraisalModal from "../VehicleAppraisalModal.vue";
import VehicleSnippet from "../lead/VehicleSnippet.vue";
import AppraisalSnippet from "../lead/AppraisalSnippet.vue";
import {currency} from "../../filters/financial";

export default {
    methods: {currency},
    components: {AppraisalSnippet, VehicleSnippet, VehicleAppraisalModal},
    mixins: [LeadPaneHelpers],
    props: {
        lead: {
            type: Object,
        },
        value: {},
        hideDerivative: {
            type: Boolean,
            default: false
        },
        isBusy: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasVehicle() {
            return false
            return this.partExchanges.length > 0
        }
    },
}
</script>

<style scoped>
    .vehicle-snippet { margin-bottom: 15px; cursor: pointer; }
</style>